// @ts-nocheck

import { RootState } from '../index';

export const selectBriefings = (state: RootState) => state.briefings;
export const selectBriefingsList = (state: RootState) => state.briefings.briefings;
export const selectCurrentBriefing = (state: RootState) => state.briefings.currentBriefing;
export const selectBriefingsLoading = (state: RootState) => state.briefings.isLoading;
export const selectBriefingsError = (state: RootState) => state.briefings.error;
export const selectBriefingsTotalCount = (state: RootState) => state.briefings.totalCount;

// Derived selectors
export const selectBriefingById = (briefingId: string) => (state: RootState) =>
  state.briefings.briefings.find(briefing => briefing.id === briefingId);

export const selectBriefingsByCompany = (companyId: string) => (state: RootState) =>
  state.briefings.briefings.filter(briefing => briefing.company_id === companyId);

export const selectBriefingsByStudy = (studyId: string) => (state: RootState) =>
  state.briefings.briefings.filter(briefing => briefing.study_id === studyId);

export const selectUpcomingBriefings = (state: RootState) => {
  const now = new Date().toISOString();
  return state.briefings.briefings.filter(briefing => briefing.start_time > now);
};

export const selectPastBriefings = (state: RootState) => {
  const now = new Date().toISOString();
  return state.briefings.briefings.filter(briefing => briefing.end_time < now);
};
